var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBlankMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 506 506",
    height: 512,
    viewBox: "0 0 506 506",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2e3e9"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.766,
    x2: 252.44,
    xlinkHref: "#lg1",
    y1: 282.468,
    y2: 365.237
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 193.195,
    x2: 373.322,
    xlinkHref: "#lg1",
    y1: 268.975,
    y2: 474.834
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.559,
    x2: 349.559,
    y1: 227.496,
    y2: 561.496
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4f8b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b8eac"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a34a9e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343168"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.749,
    x2: 280.415,
    xlinkHref: "#lg2",
    y1: 301.974,
    y2: 388.701
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.235,
    x2: 54.235,
    xlinkHref: "#lg2",
    y1: 299.393,
    y2: 282.059
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.684,
    x2: 208.916,
    xlinkHref: "#lg2",
    y1: 312.242,
    y2: 370.613
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 345.861,
    x2: 178.527,
    xlinkHref: "#lg2",
    y1: 329.373,
    y2: 198.707
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 243.791,
    x2: 335.791,
    y1: 200.654,
    y2: 245.987
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2231,
    stopColor: "#fb3f6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6075,
    stopColor: "#f12357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4003d"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 333.285,
    x2: 219.479,
    xlinkHref: "#lg2",
    y1: 256.509,
    y2: 142.703
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 221.089,
    x2: 281.089,
    y1: 132.41,
    y2: 214.41
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#ffde50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4446,
    stopColor: "#ffca65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#ffaa87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff90a4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.648 381.548 116.348 24.875 128.997-27.579 129.003 27.579 116.357-24.875c6.319-1.351 9.553-8.323 6.463-13.937l-83.975-152.588c-2.255-4.097-7.167-5.993-11.634-4.49l-74.24 24.977-81.972-27.579-81.968 27.579-74.234-24.977c-4.467-1.503-9.38.393-11.634 4.49l-83.975 152.589c-3.089 5.613.145 12.585 6.464 13.936z",
    fill: "url(#SVGID_1_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.498 375.548 114.996 24.875 127.498-27.579 127.504 27.579 115.005-24.875c6.246-1.351 9.442-8.323 6.388-13.937l-82.999-152.588c-2.228-4.097-7.084-5.993-11.499-4.49l-73.378 24.977-81.019-27.579-81.016 27.579-73.371-24.977c-4.415-1.503-9.271.393-11.499 4.49l-82.998 152.589c-3.053 5.613.143 12.585 6.388 13.936z",
    fill: "url(#SVGID_2_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m10.498 375.548 114.996 24.875 127.498-27.579 127.504 27.579 115.005-24.875c6.246-1.351 9.442-8.323 6.388-13.937l-82.999-152.588c-2.228-4.097-7.084-5.993-11.499-4.49l-73.378 24.977-81.019-27.579-81.016 27.579-73.371-24.977c-4.415-1.503-9.271.393-11.499 4.49l-82.998 152.589c-3.053 5.613.143 12.585 6.388 13.936z",
    fill: "url(#SVGID_2_)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m252.992 357.498-123.063 26.619-109.182-21.699 77.355-142.211 69.727 23.737 85.166-26.167 84.963 26.236 69.94-23.806 77.355 142.211-109.191 21.699z",
    fill: "url(#SVGID_4_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m171.98 229.511-46.485 170.912-114.997-24.875c-6.246-1.351-9.441-8.323-6.388-13.937l82.999-152.588c2.228-4.097 7.084-5.993 11.499-4.49z",
    fill: "url(#SVGID_5_)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m252.995 201.932-.003 170.913 127.504 27.578-46.482-170.912z",
    fill: "url(#SVGID_6_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m407.392 204.534-73.378 24.977 46.482 170.912 115.005-24.875c6.246-1.351 9.442-8.323 6.388-13.937l-82.999-152.588c-2.228-4.096-7.083-5.992-11.498-4.489z",
    fill: "url(#SVGID_7_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m380.496 400.423 94.73-20.49-155.176-155.175-67.055-22.825-65.965 22.455c8.899 30.82 23.976 64.144 42.191 80.92l79.616 79.616z",
    fill: "url(#SVGID_8_)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m327.672 174.249c0 41.24-33.432 142.039-74.672 142.039s-74.672-100.799-74.672-142.039 33.432-74.672 74.672-74.672 74.672 33.432 74.672 74.672z",
    fill: "url(#SVGID_9_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m327.561 178.518-37.234-37.451c-9.333-9.963-22.599-16.197-37.328-16.197-28.25 0-51.152 22.902-51.152 51.152 0 14.597 6.125 27.756 15.932 37.076l73.78 74.21c20.559-31.372 34.643-80.675 36.002-108.79z",
    fill: "url(#SVGID_10_)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 253,
    cy: 176.022,
    fill: "url(#SVGID_11_)",
    r: 51.152
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlankMap);
export default __webpack_public_path__ + "static/media/icon-blank-map.3ebe0de90610d48bc7d1dd9238ad5716.svg";
export { ForwardRef as ReactComponent };